<template>
  <div>
    <div class="fixed z-50  inset-x-0 top-0 pointer-events-none">
      <div :class="{'lg:py-8':!shrink}" class="transition-all duration-200 container mx-auto flex justify-end px-4 py-4">
        <hamburger-button  :class="{'lg:h-12':!shrink}" class="transition-all duration-200 h-8 pointer-events-auto" style="z-index:10000" v-on:toggleNav="toggleNav"></hamburger-button>
      </div>
    </div>
    <div class="fixed z-30 inset-x-0 top-0 border-b border-orange bg-white">
      <div :class="{'lg:py-8':!shrink}" class="shrink container mx-auto flex justify-between px-4 py-4">
        <a href="/" :title="siteName"><img src="/img/logo.svg" alt="Carbon Logo" class="logo" :class="{'big':!shrink}"></a>
        <div class="flex items-center mr-10">
          <a href="/contact" class="hidden md:inline-block btn-orange mr-8 px-4 py-1 text-xs lg:text-base lg:py-2" title="Get in Touch">Contact</a>

        </div>
      </div>
    </div>
    <transition name="fade">
      <div v-if="showNav" class="nav-overlay z-40">
        <div class="nav mt-10 md:mt-0">
          <ul class="m-0 p-0">
            <li v-for="link in links" class="pb-2 md:py-2 text-center"><a class="
                        site-link
                        leading-tight
                        inline-block
                        text-xl
                        md:text-4xl
                        uppercase
                        px-8
                        hover:bg-orange
                        hover:text-white" :href="link.url" :title="link.title" v-text="link.title"></a></li>
          </ul>
          <div class="w-20 border-t border-gray-500 mt-2 mb-4 md:mt-4 md:mb-6 mx-auto"></div>
          <div v-for="(set, setIndex) in supLinkSets" :key="setIndex">
            <ul class="md:flex md:justify-center p-0 m-0 md:mb-4">
              <li v-for="(link, index) in set" :class="{ sep : (index != 0)}" class="text-center py-1 md:py-0 md:mr-2">
                <a class="
                        site-link
                        leading-tight
                        inline-block
                        text-lg
                        md:text-2xl
                        px-8
                        md:px-2
                        uppercase
                        hover:bg-orange
                        hover:text-white" :href="link.url" :title="link.title" v-text="link.title"></a></li>
            </ul>
          </div>
          <!--          <ul class="md:flex md:justify-center p-0">-->
          <!--            <li v-for="(link, index) in supLinks" :class="{ sep : (index != 0)}" class="text-center py-1 md:py-0 md:mr-2">-->
          <!--              <a class="-->
          <!--                        site-link-->
          <!--                        leading-tight-->
          <!--                        inline-block-->
          <!--                        text-xl-->
          <!--                        md:text-2xl-->
          <!--                        px-8-->
          <!--                        md:px-2-->
          <!--                        uppercase-->
          <!--                        hover:bg-orange-->
          <!--                        hover:text-white" :href="link.url" :title="link.title" v-text="link.title"></a></li>-->
          <!--          </ul>-->
          <div class="w-20 border-t border-gray-500 my-4 md:my-6 mx-auto"></div>
          <ul class="md:flex md:justify-center p-0">
            <li v-for="(link, index) in terLinks" class="text-center pb-1 md:py-0">
              <a class="
                        site-link
                        leading-tight
                        inline-block
                        text-sm
                        md:text-base
                        px-8
                        md:px-2
                        uppercase
                        hover:bg-orange
                        hover:text-white" :href="link.url" :target="link.target" :title="link.title">
                <i class="fas fa-lock mr-1"></i>
                <span v-text="link.title"></span>
              </a>
            </li>
          </ul>

          <ul class="flex justify-center p-0 my-4 md:my-6 ">
            <li v-for="(link, index) in socialLinks" class="text-center py-1 md:py-0 px-1">
              <a :href="link.url" target="_blank" :title="link.title">
                <i class="text-3xl hover:text-orange fab" :class="link.icon"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import HamburgerButton from "@/components/buttons/HamburgerButton"

export default {
  data() {
    return {
      shrink: false,
      showNav: false,
      supLinkSize: 3
    }
  },
  props: {
    siteName: {
      type: String,
      default: "Carbon"
    },
    links: {
      type: Array,
      default: () => []
    },
    supLinks: {
      type: Array,
      default: () => []
    },
    terLinks: {
      type: Array,
      default: () => []
    },
    socialLinks: {
      type: Array,
      default: () => []
    },
  },
  components: {
    HamburgerButton
  },
  computed: {
    supLinkSets() {

      let [...arr] = this.supLinks;
      let res = [];
      while (arr.length) {
        res.push(arr.splice(0, this.supLinkSize));
      }
      return res;
    }
  },
  methods: {
    handleScroll() {
      this.shrink = (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50);
    },
    toggleNav(active) {
      this.showNav = active
    }
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
  }
}
</script>
<style lang="scss" scoped>
.logo {
  @apply w-auto h-8;

  @screen lg {
    transition: height 0.2s ease;
    @apply h-10;
  }

  &.big {
    @screen lg {
      @apply h-12;
    }
  }
}

.sep {
  @screen md {
    @apply border-l border-gray-900 pl-2 ;
  }
}

.shrink {
  transition: padding 0.2s ease;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.site-link {
  transition: background-color 0.25s ease-in, color 0.25s ease-in;
}

.nav-overlay {
  height: 100%;
  width: 100%;
  position: fixed; /* Stay in place */
  left: 0;
  top: 0;
  background-color: rgb(255, 255, 255); /* Black fallback color */
  background-color: rgba(255, 255, 255, 0.95); /* Black w/opacity */
  overflow-x: hidden; /* Disable horizontal scroll */

  .nav {
    position: fixed;
    width: 100%;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>